import React, { useEffect, useState } from 'react';
import { rptV3Api } from '../services/api';
import RPTV3GLNatureMappingEditor from './RPTV3GLNatureMappingEditor';
import '../styles/Panel.css';

function RPTV3GLNatureMappingPanel({ entity }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [eligible, setEligible] = useState(false);
  const [eligibilityMessage, setEligibilityMessage] = useState('');
  const [natures, setNatures] = useState([]);

  useEffect(() => {
    const loadConfigContext = async () => {
      if (!entity?.name) return;

      setLoading(true);
      setError(null);
      try {
        const [eligibilityResponse, naturesResponse] = await Promise.all([
          rptV3Api.checkEligibility(entity.name),
          rptV3Api.getNatures(),
        ]);
        setEligible(Boolean(eligibilityResponse.eligible));
        setEligibilityMessage(eligibilityResponse.message || '');
        setNatures(naturesResponse.natures || []);
      } catch (err) {
        console.error('Failed to load RPT V3 mapping context:', err);
        setEligible(false);
        setError(err.message || err.data?.error || 'Failed to load RPT V3 mapping context');
      } finally {
        setLoading(false);
      }
    };

    loadConfigContext();
  }, [entity?.name]);

  return (
    <div className="panel rpt-v3-mapping-panel">
      <h2>RPT V3 GL Nature Mappings</h2>
      <p className="panel-description">
        Review, add, edit, or disable the GL account to RPT nature mappings used by RPT V3
        for the selected entity.
      </p>

      {loading && <div className="loading">Loading RPT V3 mapping configuration...</div>}

      {error && (
        <div className="alert alert-error">
          <strong>Error:</strong> {error}
        </div>
      )}

      {!loading && !error && !eligible && (
        <div className="alert alert-info">
          <p>{eligibilityMessage || 'This entity is not eligible for RPT V3 mapping configuration.'}</p>
        </div>
      )}

      {!loading && !error && eligible && (
        <RPTV3GLNatureMappingEditor
          entity={entity}
          natures={natures}
          compact
        />
      )}
    </div>
  );
}

export default RPTV3GLNatureMappingPanel;
